import { render } from "./ElementFlip.vue?vue&type=template&id=4a631c86&scoped=true&ts=true"
import script from "./ElementFlip.vue?vue&type=script&lang=ts"
export * from "./ElementFlip.vue?vue&type=script&lang=ts"

import "./ElementFlip.vue?vue&type=style&index=0&id=4a631c86&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a631c86"]])

export default __exports__